<template>
    <b-overlay :show="pdfLoading" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block ml-2">
        <b-button variant="custom-outline-secondary" class="fs-14 mt-2" @click="downloadPDF"> Скачать итоговый протокол </b-button>
    </b-overlay>
</template>

<script>
import FileDownload from 'js-file-download';

export default {
    name: 'fl44-unknown-volume-download-purchase-final-protocol-pdf-button',
    props: {
        purchaseId: {
            type: Number,
            required: true
        },
        regNumber: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            pdfLoading: false
        };
    },
    methods: {
        downloadPDF() {
            this.pdfLoading = true;
            this.$api.products.fl44UnknownVolume.purchases
                .downloadPurchaseFinalProtocolPdf(this.purchaseId)
                .then((response) => {
                    const fileName = `Итоговый протокол к извещению ${this.regNumber}.pdf`;
                    FileDownload(response.data, fileName);
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.pdfLoading = false;
                });
        }
    }
};
</script>
